import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import FlipNumbers from "react-flip-numbers";

function TimelineCounter() {
  const item = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
  };

  const hour = 2003;
  const [[year], setYear] = useState([hour]);

  const tick = () => {
    setYear([year + 1]);
  };

  useEffect(() => {
    let timerId;

    if (year < 2020) {
      timerId = setInterval(() => tick(), 700);
    } else if (year > 2019 && year < 2022) {
      timerId = setInterval(() => tick(), 1200);
    }
    return () => clearInterval(timerId);
  });

  return (
    <motion.div
      variants={item}
      initial="hidden"
      animate="show"
      transition={{ duration: 1 }}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 800,
      }}
    >
      <FlipNumbers
        play
        color="#fff"
        background="transparent"
        width={55}
        height={80}
        numbers={`${year}`}
      ></FlipNumbers>
    </motion.div>
  );
}

export default TimelineCounter;
